<template>
  <el-dialog
    :title="this.id ? '修改设备品牌' : '新增设备品牌'"
    @close="handleCancle"
    @closed="reset"
    :visible="visible"
    :close-on-click-modal="false"
    width="560px"
  >
    <el-form
      ref="brandForm"
      v-loading="loading"
      :model="brandForm"
      :rules="brandFormRules"
      label-width="110px"
    >
      <el-row>
        <el-col :span="24">
          <el-form-item label="所属设备类型" prop="categoryId">
            <!-- <el-input
              v-if="!isDetail"
              v-model="brandForm.categoryId"
              :maxlength="50"
              placeholder="请输入"
            ></el-input>
            <span v-else>{{ brandForm.categoryId }}</span> -->
            <el-select
              :loading="typeLoading"
              style="width: 100%"
              v-model="brandForm.categoryId"
              placeholder="请选择"
            >
              <el-option
                v-for="item in categoryList"
                :key="item.id"
                :value="item.id"
                :label="item.categoryName"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="品牌名称" prop="typeName">
            <!-- <el-input
              v-if="!isDetail"
              v-model="brandForm.typeName"
              :maxlength="50"
              placeholder="请输入"
            ></el-input>
            <span v-else>{{ brandForm.typeName }}</span> -->
            <el-input v-model="brandForm.typeName" :maxlength="50" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="品牌编码" prop="typeNo">
            <!-- <el-input
              v-if="!isDetail"
              :maxlength="50"
              v-model="brandForm.typeNo"
              placeholder="请输入"
            ></el-input>
            <span v-else>{{ brandForm.typeNo }}</span> -->
            <el-input :maxlength="50" v-model="brandForm.typeNo" placeholder="请输入"></el-input>
            <NoTips />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="状态" prop="status">
            <!-- <el-radio-group v-if="!isDetail" v-model="brandForm.status">
              <el-radio :label="0">启用</el-radio>
              <el-radio :label="1">停用</el-radio>
            </el-radio-group>
            <span v-else>{{ brandForm.status }}</span> -->
            <el-radio-group v-model="brandForm.status">
              <el-radio v-for="(item, index) in statusType" :key="index" :label="item.typeNum">{{
                item.typeName
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item label="关联协议" prop="deviceProtocol">
          <!-- <el-radio-group v-if="!isDetail" v-model="brandForm.status">
              <el-radio :label="0">启用</el-radio>
              <el-radio :label="1">停用</el-radio>
            </el-radio-group>
            <span v-else>{{ brandForm.status }}</span> -->
          <el-checkbox-group v-model="brandForm.deviceProtocol">
            <el-col :span="8" v-for="item in dealList" :key="item.id">
              <el-checkbox :label="item.id">
                <Ellipsis :texts="item.protocolName" :length="12" />
              </el-checkbox>
            </el-col>
          </el-checkbox-group>
        </el-form-item>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancle">取消</el-button>
      <el-button type="primary" :loading="btnLoading" @click="handleSubmit">确定</el-button>
    </span>
    <el-dialog append-to-body width="400px" title="提示" :visible="pushVisible">
      <el-row>
        <span>新增设备品牌成功，确认是否跳转设备系列。</span>
      </el-row>
      <el-row slot="footer" class="dialog-footer" @close="handleNoPush">
        <el-button @click="handleNoPush">取消</el-button>
        <el-button type="primary" @click="handlePush">确定</el-button>
      </el-row>
    </el-dialog>
    <ValidatPass ref="validatPass" @back="validateBack" />
  </el-dialog>
</template>
<script>
import deviceBrandApi from 'api/home/device-mangement/device-brand';
import deviceTypeApi from 'api/home/device-mangement/device-type';
import Ellipsis from '@/components/Ellipsis';
import dealApi from 'api/home/deal-mangement';
import ValidatPass from '@/components/PermissionPassword/ValidatPass';
import NoTips from '../device-components/NoTips';
import statusType from '@/config/status';
import regex from '@/config/regex';
export default {
  components: {
    ValidatPass,
    NoTips,
    Ellipsis
  },
  data() {
    const validateNo = (rule, value, callback) => {
      const { noReg } = regex;
      if (!value) {
        callback(new Error('请输入设备品牌编码'));
        return;
      }
      if (!noReg.test(value)) {
        callback(new Error('请用拼音或相应英文设置编码，以"_"或"-"进行连接'));
      } else {
        callback();
      }
    };
    return {
      statusType,
      id: '',
      isDetail: false,
      visible: false,
      loading: false,
      btnLoading: false,
      categoryList: [],
      typeLoading: false,
      dealList: [],
      brandForm: {
        categoryId: '',
        typeName: '',
        typeNo: '',
        status: 0,
        deviceProtocol: []
      },
      brandFormRules: {
        categoryId: [{ required: true, message: '请选择设备类型', trigger: 'change' }],
        typeName: [{ required: true, message: '请输入设备品牌名称', trigger: 'blur' }],
        typeNo: [{ required: true, validator: validateNo, trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      },
      pushVisible: false
    };
  },
  methods: {
    init(data) {
      this.visible = true;
      this.getDealList();
      this.getTypeList();
      this.id = data.id || '';
      this.id && this.getBrandDetail();
    },
    handleCancle() {
      this.visible = false;
    },
    handleSubmit() {
      this.$refs.brandForm.validate(validated => {
        if (!validated) {
          return;
        }
        if (this.id) {
          this.editType();
        } else {
          this.addType();
        }
      });
    },
    addType() {
      this.btnLoading = true;
      const data = {
        categoryId: this.brandForm.categoryId,
        typeName: this.brandForm.typeName,
        typeNo: this.brandForm.typeNo,
        status: this.brandForm.status,
        protocolList: this.brandForm.deviceProtocol
      };
      deviceBrandApi
        .addDeviceBrand(data)
        .then(res => {
          const {
            data: { code }
          } = res;
          if (code !== 200) {
            return;
          }
          this.$message.success('新增设备品牌成功');
          this.$emit('back', 0);
          this.pushVisible = true;
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    editType() {
      const data = {
        id: this.id,
        categoryId: this.brandForm.categoryId,
        typeName: this.brandForm.typeName,
        typeNo: this.brandForm.typeNo,
        status: this.brandForm.status,
        protocolList: this.brandForm.deviceProtocol
      };
      this.$refs.validatPass.init(data, 11, true);
    },
    handleNoPush() {
      this.pushVisible = false;
      this.visible = false;
    },
    handlePush() {
      this.$router.push({ path: '/home/deviceseries' });
    },
    reset() {
      this.$refs.brandForm.resetFields();
      this.categoryList = [];
      this.dealList = [];
      this.loading = false;
      this.typeLoading = false;
      this.btnLoading = false;
      this.id = '';
      this.isDetail = false;
      this.pushVisible = false;
    },
    getBrandDetail() {
      this.loading = true;
      deviceBrandApi
        .getDeviceBrandDetail({ id: this.id })
        .then(res => {
          const {
            data: { data, code }
          } = res;
          if (code !== 200) {
            return;
          }
          this.brandForm = {
            typeName: data.typeName,
            typeNo: data.typeNo,
            categoryId: data.categoryId,
            deviceProtocol: data.deviceProtocol
              .filter(item => {
                return item.checked;
              })
              .map(item => {
                return item.id;
              }),
            status: data.status
          };
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getTypeList() {
      this.typeLoading = true;
      deviceTypeApi
        .getDeviceTypeList()
        .then(res => {
          const { data } = res.data;
          this.categoryList = data;
        })
        .finally(() => {
          this.typeLoading = false;
        });
    },
    getDealList() {
      dealApi.getAllDealList().then(res => {
        const {
          data: { data, code }
        } = res;
        if (code !== 200) {
          return;
        }
        this.dealList = data;
      });
    },
    validateBack() {
      this.$message.success('设备品牌修改成功');
      this.$emit('back', 1);
      this.visible = false;
    }
  }
};
</script>